var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClockSGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 7.12H11.2198L13.9598 4.3C11.2298 1.6 6.80976 1.5 4.07976 4.2C1.34976 6.91 1.34976 11.28 4.07976 13.99C6.80976 16.7 11.2298 16.7 13.9598 13.99C15.3198 12.65 15.9998 11.08 15.9998 9.1H17.9998C17.9998 11.08 17.1198 13.65 15.3598 15.39C11.8498 18.87 6.14976 18.87 2.63976 15.39C-0.86024 11.92 -0.89024 6.28 2.61976 2.81C6.12976 -0.66 11.7598 -0.66 15.2698 2.81L17.9998 0V7.12ZM9.49976 5V9.25L12.9998 11.33L12.2798 12.54L7.99976 10V5H9.49976Z",
    fill: "#3B2723"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockSGrey);
export default __webpack_public_path__ + "static/media/icon-clock-s-grey.5aadb3a0d1b7210b62960c1ce71b56c6.svg";
export { ForwardRef as ReactComponent };